<template>
    <div class="layout-canvas" :class="{'layout-canvas__open': isOpen}">
        <div class="layout-canvas--shadow" @click="$emit('toggle')"></div>
        <div class="layout-canvas--inner">
            <div class="layout-canvas--close">
                <btn theme="link" size="sm" icon="close" title="Close" @click="$emit('toggle')"/>
            </div>

            <router-link v-if="user" :to="`/community/profile/${user.id_user}`" class="account-box px-2 mb-3" @click.native="$emit('toggle')">
                <img class="account-box--image img-frame" :src="user.profileImage" :alt="user.fullname">
                <div class="account-box--details">
                    <div class="account-box--name text-truncate">{{ user.fullname }}</div>
                    <div class="account-box--subtitle text-truncate">{{ user.email }}</div>
                </div>
            </router-link>

            <div class="navigation mb-3">
                <layout-navigation :nav-items="navItems" @click.native="$emit('toggle')"/>

                <nav-item class="mobile-search" v-bind="searchNavItem" @click.native="$emit('toggle')"/>
            </div>

            <div class="layout-canvas--footer mt-auto px-2">
                <a href="http://www.ghst.de/">
                    <img src="/img/hertie-logo.svg" alt="Hertie Stiftung" class="layout-footer--logo" target="_blank">
                </a>
                <div class="mt-3">
                    <btn theme="none" route="landing_impress">Impressum</btn>
                    <span class="px-1">|</span>
                    <btn theme="none" route="landing_privacy">Datenschutz</btn>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .layout-canvas {
        position: fixed;
        top: 0;
        left: -$layout-sidebar-width;
        bottom: 0;
        right: 100%;
        z-index: 3;
        transition: left .15s, right .15s;

        .layout-navigation {
            width: 100%;
        }
        .nav .nav-item .nav-link {
            font-size: $font-size-base;
        }
        .nav .nav-item .nav-icon {
            font-size: 24px;
        }

        .mobile-search {
            width: 100%;

            .nav .nav-item .nav-link {
                font-size: $font-size-base;
            }
            .nav-icon {
                display: block;
                font-size: 24px;
                width: 40px;
                padding-right: 20px;
                text-align: center;
            }
            .nav-link {
                display: flex;
                align-items: center;
                padding: 9px 15px;
                font-size: $font-size-base;
                line-height: 22px;
                position: relative;
                color: #666666;
                background-color: transparent;
                transition: background-color .2s, color .2s;
            }
        }
    }
    .layout-canvas--shadow {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: $white;
        opacity: 0;
        transition: opacity .15s;
        z-index: 3;
    }
    .layout-canvas--inner {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 85%;
        min-width: $layout-sidebar-width;
        max-width: 400px;
        background-color: $white;
        padding-bottom: $spacer-2;
        box-shadow: 1px 0 3px rgba($black, .15);
        overflow-y: auto;
        z-index: 4;

        .nav-link:hover {
            background-color: $dark-5 !important;
        }
    }
    .layout-canvas--close {
        display: flex;
        align-items: center;
        height: $layout-header-height;
        padding-left: $spacer-2;

        .btn {
            font-size: 28px;
        }
    }
    .layout-canvas--footer {
        font-size: $font-size-sm;

        a {
            color: $dark-70;
        }
    }
    .layout-canvas__open {
        left: 0;
        right: 0;

        .layout-canvas--shadow {
            opacity: .65;
        }
    }
    .account-box {
        display: flex;
        align-items: center;
    }
    .account-box--details {
        min-width: 0;
    }
    .account-box--image {
        display: block;
        height: 60px;
        width: 60px;
        margin-right: $spacer-2;
        flex-shrink: 0;
    }
    .account-box--name {
        color: $dark-80;
        font-weight: bold;
    }
    .account-box--subtitle {
        font-size: $font-size-sm;
        color: $dark-40;
    }
</style>

<script>
    export default {
        props: {
            hideSearch: {type: Boolean, default: false},
            navItems: {type: Array, default: () => []},
            isOpen: Boolean,
        },

        data() {
            return {
                searchNavItem: {
                    icon: 'magnify',
                    label: 'Suche',
                    route: 'community_search',
                },
            };
        },

        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
        },
    };
</script>
